import { formatQuotedPrice } from "@shared-core/domain/formatters";
import { DELIVERY_NOT_YET_PRICED } from "@shared-core/domain/checkout-delivery";
import type { CustomerBasketTotals } from "@shared-core/data/customer-basket-types";

// The basket's and the checkout's totals, as the backend worked them out: goods and
// delivery ex VAT, the VAT, and the total including VAT (the amount a card payment takes). Nothing is added
// up here. A figure the server could not work out (a line with no VAT treatment) is a dash; while a delivery is
// not yet priced the delivery figure says so, and the totals leave it out (order to invoice doc 104 §5.6).
function money(pence: number | null): string {
  return pence === null ? "—" : formatQuotedPrice(pence);
}

export function BasketTotals({ totals }: { totals: CustomerBasketTotals }) {
  return (
    <dl className="space-y-1.5 text-sm tabular-nums">
      <div className="flex justify-between gap-4">
        <dt className="text-muted-foreground">Goods (ex VAT)</dt>
        <dd>{money(totals.goods_pence)}</dd>
      </div>
      <div className="flex justify-between gap-4">
        <dt className="text-muted-foreground">Delivery (ex VAT)</dt>
        <dd className="text-right">
          {totals.has_delivery_not_yet_priced
            ? DELIVERY_NOT_YET_PRICED
            : money(totals.delivery_pence)}
        </dd>
      </div>
      <div className="flex justify-between gap-4">
        <dt className="text-muted-foreground">VAT</dt>
        <dd>{money(totals.vat_pence)}</dd>
      </div>
      <div className="flex justify-between gap-4 border-t pt-2 text-base font-semibold">
        <dt>Total including VAT</dt>
        <dd>{money(totals.total_inc_vat_pence)}</dd>
      </div>
    </dl>
  );
}
